var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrFavicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#166564;}\n\t.st1{fill:#166564;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    className: "st0",
    width: 1210,
    height: 1210
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M874.2,447.6c1.8-3.4,3.5-6.8,5-10.3h42.4V277.7H796.4l-1.2-0.7l-0.2,0.7H670.9l-2.5-0.7v0.7h-390v159.5h223.3 V923h196.6v-0.7h1.1v-31.3V437.3V319.7c38.1,10.3,64.8,50.6,59.8,89.7c-0.4,3.2-1.1,6.4-1.8,9.6l-4.9,18.2L732.5,512l-13.5,51.3 h30.6c0.4-0.4,0.7-0.4,1.1-0.4c3.6-12.8,6.8-25.3,10.3-38.1c1.1-4.3,2.1-8.5,3.6-12.8c6.8-25.1,13.5-49.9,20.2-74.8 c9.9-36.5,19.8-73.1,30-110.8l1.4,0.7c35.3,20.3,50.2,69.4,29.6,105.8l-2.4,4.3L801.6,512l-28.1,51.3h67.7 c12.5,0,23.5,7.5,27.8,19.2c0.4,0.7,0.7,1.8,1.1,2.5c0,0,0,0,0,0.4c0.9,2.8,1.2,5.5,1.2,8.3c0,1.8-0.2,3.5-0.5,5.2 c0.1-0.3,0.1-0.5,0.2-0.8c0,0.4-0.1,0.8-0.2,1.2v0.7c0,0.4,0,0.7-0.4,1.1v0.4c-1.1,5-3.9,9.3-7.1,12.8l-1.1,1.1l-17.8,18.5 L769.5,710c-8.9,8.9-10.7,22.4-4.3,33.1l1.8,2.8l65.9,114.3l2.5,4.6l15,26l16.4,32.1h39.2l-27.8-48.1l-15-26l-9.3-16L794.8,730 l72.3-74.8l17.8-18.2l1.1-1.1c7.5-7.5,12.8-16.7,15.7-27.1c0.4-0.7,0.7-2.1,0.7-3.6c0-1.4,0.4-2.1,0.7-3.2c0-1.1,0.4-1.4,0.4-1.8 l0.4-1.8c0-1.1,0-1.8,0.4-2.5c0.4-1.1,0-2.1,0-3.2c0-5.7-0.7-11.4-2.5-17.1c-0.4-1.8-1.1-3.9-1.8-5.7 c-9.3-23.9-32.1-39.5-57.7-39.5h-13.5l2.1-3.6L874.2,447.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M863.2,613.9c3.2-3.6,6.1-7.8,7.1-12.8C868.9,605.7,866.4,610.3,863.2,613.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M793,610.7c0-11.4-9.3-20.7-20.7-20.7c-16.2,0-28.1,18.8-15.1,35.8C774.2,638.8,793,626.9,793,610.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M869.9,601.1c-1.4,4.6-3.9,9.3-7.1,12.8C866.4,610.3,868.9,606.1,869.9,601.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrFavicon);
export default __webpack_public_path__ + "static/media/tr-favicon.6a59905e551f68d27837eeef80613ebe.svg";
export { ForwardRef as ReactComponent };